export default __webpack_public_path__ + "static/media/bangalore.043e1880.png";